import { render, staticRenderFns } from "./PartnerUnjoin.vue?vue&type=template&id=3835be00&"
import script from "./PartnerUnjoin.vue?vue&type=script&lang=js&"
export * from "./PartnerUnjoin.vue?vue&type=script&lang=js&"
import style0 from "./PartnerUnjoin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports